<template>
    <div class="columns is-marginless is-multiline is-mobile">
        <div class="column is-12 px-0 py-0" v-if="!isMultiLang">
            <div class="column is-12">
                <div class="field">
                    <p
                        v-t="'projectConfiguration.project_title'"
                        class="label has-text-black has-text-weight-bold"
                    />
                    <p class="control">
                        <input
                            v-model="project.title"
                            :class="{ 'is-static': !canEdit }"
                            :readonly="!canEdit"
                            :placeholder="$t('project_title_input_placeholder')"
                            class="input"
                            type="text"
                        />
                    </p>
                </div>
            </div>
            <div class="column is-12">
                <div class="field">
                    <p
                        v-t="'projectConfiguration.project_description'"
                        class="label has-text-black has-text-weight-bold"
                    />
                    <p class="control">
                        <textarea
                            v-model="project.description"
                            :class="{ 'is-static': !canEdit }"
                            :readonly="!canEdit"
                            :placeholder="
                                $t('project_description_input_placeholder')
                            "
                            class="textarea"
                        />
                    </p>
                </div>
            </div>
        </div>
        <div class="column is-12 px-0 py-0" v-else>
            <div class="tabs s-toggle is-fullwidth" >
                <ul>
                    <li v-for="langCode in $store.getters.project.langs" :key="langCode" :class="{'is-active':activeLanguage==langCode}">
                        <a class="lang-link" @click="activeLanguage = langCode">
                            <span>{{ $t('LANG_'+langCode) }}</span><span class="is-required" v-if="langCode==$store.getters.project.defaultLang">*</span>
                        </a>
                    </li>
                </ul>
            </div>
            <div v-for="langCode in $store.getters.project.langs" :key="langCode" class="lang-field" :class="{'is-active':activeLanguage==langCode}">
                <div class="field mb-5">
                    <label
                        class="label"
                        >{{ $t('Object.title_label') }}</label
                    >
                    <div class="control">
                        <input
                            v-model="project.titlePerLang[langCode]"
                            :class="{ 'is-static': !canEdit }"
                            :readonly="!canEdit"
                            :placeholder="$t('project_title_input_placeholder')"
                            class="input"
                            type="text"
                        />
                    </div>
                </div>
                <div class="field mb-5">
                    <label class="label">{{
                        $t('Object.description_label')
                    }}</label>
                    
                    <div class="control">
                       
                        <textarea
                            v-model="project.descriptionPerLang[langCode]"
                            :class="{ 'is-static': !canEdit }"
                            :readonly="!canEdit"
                            :placeholder="
                                $t('project_description_input_placeholder')
                            "
                            class="textarea"
                        ></textarea>
                    </div>
                </div>
            </div>
        </div>
        <div class="column is-12">
            <div class="field">
                <!--<v-select label="label" :options="langs"></v-select>-->
                <p
                    v-t="'enabled_languages'"
                    class="label has-text-black has-text-weight-bold"
                />
                <multiselect 
                    class="select-lang" 
                    v-model="project.langs" 
                    :options="langCodes" 
                    :custom-label="langLabel" 
                    :multiple="true"
                    :selectLabel="$t('select_langs_select')"
                    :selectedLabel="$t('select_langs_selected')"
                    :deselectLabel="$t('select_langs_deselect')"
                    :placeholder="$t('select_langs')"
                    ></multiselect>
            </div>
            
        </div>
        <div class="column is-12" v-if="project.langs && project.langs.length">
            <div class="field">
                <p
                    v-t="'default_language'"
                    class="label has-text-black has-text-weight-bold"
                />
                <multiselect 
                    class="select-lang" 
                    v-model="project.defaultLang" 
                    :options="project.langs" 
                    :custom-label="langLabel" 
                    :multiple="false"
                    :selectLabel="$t('select_langs_select')"
                    :selectedLabel="$t('select_langs_selected')"
                    :deselectLabel="$t('select_langs_deselect')"
                    :placeholder="$t('select_langs')"
                    ></multiselect>
            </div>
            <p class="is-muted is-size-7">{{ $t('default_language_desc') }}</p>
        </div>
        <!--<div class="column is-12">
            <div v-if="isAdmin" class="field">
                <p
                    v-t="'projectConfiguration.suggested_tags'"
                    class="label has-text-black has-text-weight-bold mb-0"
                />
                <p class="is-size-7 is-italic has-text-grey mb-2">
                    {{ $t('projectConfiguration.suggested_tags_description') }}
                </p>
                <p class="control">
                    <InputTags
                        v-model="project.suggestedTags"
                        :class="{ 'is-static': !canEdit }"
                        :readonly="!canEdit"
                    />
                </p>
            </div>
        </div>-->
        <!--<div class="columns is-mobile is-vcentered px-3 py-3">
            <div class="column">
                <p
                    v-t="`project.settings.comments`"
                    class="title is-6 mb-0"
                ></p>

                <p class="is-size-7 is-italic has-text-grey pt-1">
                    {{ $t(`project.settings.comments_description`) }}
                </p>
            </div>
            <div class="column is-3 has-text-right">
                <label class="switch">
                    <input
                        v-model="project.configuration.global.comments"
                        type="checkbox"
                    />
                    <span class="slider round"></span>
                </label>
                    
            </div>
        </div>-->
    </div>
</template>

<script>
import InputTags from '@/components/InputTags';
import { fetchItems } from '@/services/API';
import _ from 'underscore';
import { LANG_CODES } from '@/lib/constants';
export default {
    components: {
        InputTags,
    },
    model: {
        prop: 'project',
    },
    props: {
        project: {
            type: Object,
            default: () => {
                return {};
            },
        },
        canEdit: { type: Boolean, default: false },
        isAdmin: { type: Boolean, default: false },
    },
    data() {
        return {
            folders: [],
            selectedFolder: this.project.folder || {},
            showDropdown: false,
            value: null,
            options: ['list', 'of', 'options'],
            activeLanguage: this.$store.getters.project.langs && this.$store.getters.project.defaultLang ? this.$store.getters.project.defaultLang : this.$store.getters.project.langs && !this.$store.getters.project.defaultLang ? this.$store.getters.project.langs[0] : '',
        };
    },
    computed: {
        hasFolder() {
            return !_.isEmpty(this.project.folder);
        },
        langCodes() {
            return LANG_CODES;
        },
        isMultiLang() {
            return this.$store.getters.project.langs && this.$store.getters.project.langs.length > 0;  
        },
    },
    mounted() {
        this.fetchFolders();
    },
    watch: {
        
    },
    methods: {
        async fetchFolders() {
            const folders = await fetchItems('folder');
            this.folders = folders.data;
        },
        selectFolder(folder) {
            this.selectedFolder = folder;
            this.showDropdown = false;
            this.project.folder = folder;
        },
        langLabel(code) {
            return this.$t("LANG_" + code);
        },
    },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

.select-lang /deep/ .multiselect__content-wrapper{
    position:relative;
    max-height: 200px;
}
.select-lang /deep/ .multiselect__input{
    font-size: 1rem;
}
.select-lang /deep/ .multiselect__option{
    font-size: 1rem;
}
.select-lang /deep/ .multiselect__tag{
    background: var(--eduloc-red);
}
.select-lang /deep/ .multiselect__tag-icon:after{
    color: #FFFFFF;
}
.select-lang /deep/ .multiselect__tag-icon:focus, .select-lang /deep/ .multiselect__tag-icon:hover{
    background: var(--eduloc-red-dark);
}
.select-lang /deep/ .multiselect__option--highlight, .select-lang /deep/ .multiselect__option--highlight::after{
    background: var(--eduloc-red);
}

.lb-select-folder .control .button {
    height: 2.5rem;
}
.label {
    font-weight: normal;
}
.dropdown.is-fullwidth {
    display: flex;
}

.dropdown.is-fullwidth * {
    width: 100%;
}

.lang-field{
    display: none;
}

.lang-field.is-active{
    display: block;
}

.is-required{
    color: var(--eduloc-red);
    font-size: 0.75rem;
}

.lang-link{
    text-decoration: none !important;
}
</style>
